import { Icon, InlineStack, Text, Tooltip } from '@shopify/polaris'
import { QuestionCircleIcon } from '@shopify/polaris-icons'

import styles from './HelpIcon.module.css'
interface HelpIconProps {
  children: any
}

export const LegacyHelpIcon = ({ children }: HelpIconProps) => (
  <Tooltip content={children} dismissOnMouseOut={false}>
    <span className={styles.wrap}>
      &nbsp;
      <Icon source={QuestionCircleIcon} tone="base" />
    </span>
  </Tooltip>
)

interface LegacyHelpLabelProps {
  title: string
  children: any
}

export const LegacyHelpLabel = ({ title, children }: LegacyHelpLabelProps) => (
  <span>
    {title} <LegacyHelpIcon>{children}</LegacyHelpIcon>
  </span>
)

export const HelpIcon = ({ children }: HelpIconProps) => (
  <Tooltip content={children} dismissOnMouseOut={false}>
    <Icon source={QuestionCircleIcon} tone="base" />
  </Tooltip>
)

interface HelpLabelProps {
  tooltip?: any
  children: any
}

export const HelpLabel = ({ tooltip, children }: HelpLabelProps) => (
  <>
    {tooltip && (
      <InlineStack blockAlign="center">
        <Text as="span">{children}</Text>&nbsp;
        <HelpIcon>{tooltip}</HelpIcon>
      </InlineStack>
    )}
    {!tooltip && <Text as="span">{children}</Text>}
  </>
)

export const HelpTitle = ({ title, children }: LegacyHelpLabelProps) => (
  <Text variant="headingMd" as="h2">
    {title}
    <LegacyHelpIcon>{children}</LegacyHelpIcon>
  </Text>
)
